export default {
    events: {},
    modals: {},
    ref: {},
    routes: {},
    services: {}
};
